import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { v4 as uuidv4 } from 'uuid';
import PeopleIcon from '@material-ui/icons/People';
import MaterialIcon from '@material-ui/core/Icon';
import BigButton from '~/styles/components/BigButton';
import SubTitle from '~/components/SubTitle';
// import emergency from '~/assets/red-alert-hdpi.png';

import PharmacyReport from '~/pages/Reports/pages/Pharmacy';
import PatientReport from '~/pages/Reports/pages/Patient';
import BloodReport from '~/pages/Reports/pages/Blood';
import InfusionReport from '~/pages/Reports/pages/Infusion';
import EmergencyReport from '~/pages/Reports/pages/Emergency';

import { Container, List } from '../Maps/styles';
import { Content } from './styles';

const routes = [
  {
    icon: <MaterialIcon className="icon-infusion-kit" />,
    routename: 'Farmácia',
    pathname: '/reports/pharmacy',
    id: uuidv4(),
  },
  {
    icon: <PeopleIcon />,
    routename: 'Pacientes',
    pathname: '/reports/patients',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-blood-calendar" />,
    routename: 'Sangramentos',
    pathname: '/reports/bloods',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-drug-calendar" />,
    routename: 'Infusões',
    pathname: '/reports/infusions',
    id: uuidv4(),
  },
  {
    icon: <MaterialIcon className="icon-emergency" />,
    routename: 'Emergências',
    pathname: '/reports/emergencies',
    id: uuidv4(),
  },
];

const Reports = () => {
  const history = useHistory();
  const { location } = history;

  function handleClick(page) {
    history.push(page);
  }

  useEffect(() => {
    const titles = {
      '/reports/patients': 'Relatório de Pacientes | ClickHemofilia',
      '/reports/bloods': 'Relatório de Sangramentos | ClickHemofilia',
      '/reports/infusions': 'Relatório de Infusões | ClickHemofilia',
      '/reports/emergencies': 'Relatório de Emergências | ClickHemofilia',
    };
    document.title = titles[location.pathname] || 'Relatório de Farmácia | ClickHemofilia';
  }, [location.pathname]);

  function handleTab(param) {
    switch (param) {
      case '/reports/pharmacy':
        return <PharmacyReport />;

      case '/reports/patients':
        return <PatientReport />;

      case '/reports/bloods':
        return <BloodReport />;

      case '/reports/infusions':
        return <InfusionReport />;

      case '/reports/emergencies':
        return <EmergencyReport />;

      default:
        return <PharmacyReport />;
    }
  }

  return (
    <Container>
      <SubTitle>Emissão de relatórios</SubTitle>

      <List>
        {routes.map(({ id, pathname, routename, icon }, index) => {
          return (
            <BigButton
              key={id}
              onClick={() => handleClick(pathname)}
              icon={icon}
              selected={
                index === 0 && location.pathname === '/reports' // Select the first element when open page
                  ? true
                  : pathname === location.pathname
              }
            >
              {routename}
            </BigButton>
          );
        })}
      </List>

      <Content>{handleTab(location.pathname)}</Content>
    </Container>
  );
};

export default Reports;
